// Imports
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import styled from 'styled-components/macro';
import Item from './item';
import { LinkProps } from 'react-router-dom';


// Styled components
const Wrapper = styled.figure`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2.5rem;
	
	width: 100%;
	
	margin-top: 4.56rem;
	padding-top: 3.75rem;
	padding-bottom: 3.75rem;
	
	background-color: hsl(36, 100%, 95%);
	box-shadow: 0 0 0 100vw hsl(36, 100%, 95%);
	clip-path: inset(0 -100vw);
	
	@media (max-width: 48rem) {
		padding: 3.75rem 2.5rem;
	}
`;

const Heading = styled.figcaption`
	color: hsl(36, 56%, 69%);
	text-align: center;
	font-family: Zilla Slab;
	font-size: 3.125rem;
	font-weight: 600;
	line-height: 1;
	
	@media (max-width: 48rem) {
		font-size: 2.5rem;
	}
`;

const Steps = styled.ul`
	display: flex;
	width: 100%;
	justify-content: center;
	column-gap: 2.5rem;
	row-gap: 1.7325rem;
	flex-wrap: wrap;
	list-style: none;
`;


// Define the accepted props
interface BaseLink {
	text: string;
}

type LinkType = Omit<LinkProps, 'color'> & BaseLink;

type AnchorType = { href: string } & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color' | 'href'> & BaseLink;

type ItemLink = LinkType | AnchorType;

export interface BannerListItem {
	prefix?: string;
	icon?: IconDefinition;
	label: string;
	description: string;
	link?: ItemLink;
}

interface Props extends React.PropsWithChildren {
	items: BannerListItem[];
	heading?: string;
	className?: string;
}


// Function component
const BannerWithList: React.FC<Props> = ({ items: steps, heading, className, children }) => (
	<Wrapper className={className}>
		{heading && <Heading>{heading}</Heading>}
		
		<Steps>
			{steps.map((step, i) => (
				<Item key={i} {...step} />
			))}
		</Steps>
		
		{children}
	</Wrapper>
);

export default BannerWithList;
